import store from './store';
import { fetcher } from './fetcher';
import { GlobalModal } from './scripts/global/modal';
import { initializeAddClassMethod } from './helpers';
import { getMeasurementsAnswer, getMultiSelectedAnswer, getSingleAnswer, handleQuizProcess } from './quiz-handler';
import { Url } from './common';

let isPagesFilled = false;

export const answerStore = {
  getProducts: function () {
    return store.get('noMeatProducts') || {};
  },
  getNoMeatChecked: function () {
    return store.get('noMeatIconChecked') || {};
  },
  removeNoMeatProducts: function () {
    return localStorage.removeItem('noMeatProducts');
  },
  setNoMeatProducts: function (key, value) {
    let answer = this.getProducts();
    answer[key] = value.id;
    store.set('noMeatProducts', answer);
  },
  setNoMeatChecked: function (key, value) {
    let answer = this.getNoMeatChecked();
    answer[key] = value;
    store.set('noMeatIconChecked', answer);
  },
};

/**
 * Stores the theme only if it is different than the already stored one
 * @param {HTMLElement} element - The target HTML element
 */
export const storeTheme = element => {
  let bodyClass = element.dataset['bodyClassValue'];
  const storedBodyClassData = store.getAnswers().bodyClass || store.get('bodyClass');
  if (bodyClass !== storedBodyClassData) {
    window.setAnswer('bodyClass', bodyClass);
  }
};

/**
 * Storing dataset key and value from user answer to the store
 * @param {HTMLElement} answer - The target HTML element
 */
export const dietAnswer = element => {
  if (element.classList.contains('bodyClass')) {
    storeTheme(element);
  }

  window.setAnswer(element.dataset['key'], parseInt(element.dataset['value']));

  handleQuizProcess(getSingleAnswer(element), element, handleRedirect);
};

function handleRedirect(element) {
  if (element.dataset['href']) {
    window.location.href = window.getHost() + element.dataset['href'];
  }
}

/**
 * Checks if there is a valid index, creates object with measurements values and sets them in the storage
 * @param {HTMLElement} input The target element
 * @param {object} measurements An empty object that collects the measurements keys and values
 */
export const handleMeasurementsData = (input, measurements = {}) => {
  let measurement = {
    name: input.getAttribute('data-measurement'),
    type: input.getAttribute('name'),
    measuring_in: input.getAttribute('data-measuring_in'),
    value: input.value,
  };

  measurements[input.getAttribute('data-key')] = measurement;

  window.setAnswer('measurements', measurements);
  window.setAnswer(input.getAttribute('data-key'), input.value);
};

/**
 * Sets input key value if the id of the target element is not 'noMeat'
 * @param {HTMLElement} input The target element
 */
export const setInputAnswer = input => {
  if (input.id !== 'noMeat') {
    window.setAnswer(input.getAttribute('data-key'), input.checked ? Number(input.getAttribute('data-value')) : 0);
  }
};

/**
 * Remove the previous measurements data
 * @param {HTMLElement} form - Collection of the user inputs from the hidden form
 */
export const removePreviousData = hiddenFormInputs => {
  for (let i of hiddenFormInputs) {
    window.removeAnswer(i.dataset.key);
  }
};

/**
 * Collecting the user measurements inputs from the form and storing the answers
 * @param {HTMLElement} form - Collection of the user inputs
 */
export const saveFormAnswers = form => {
  const clearAll = document.querySelector('.clearAll input');

  if (clearAll) {
    window.setAnswer(clearAll.getAttribute('data-key'), '');
  }

  if (form.classList.contains('measurements')) {
    let measurements = {};

    let activeForm;
    let hiddenForm;
    const forms = document.querySelectorAll('[id*="tab-content-"]');

    for (let form of forms) {
      !form.classList.contains('hidden') ? (activeForm = form) : (hiddenForm = form);
    }

    hiddenForm && removePreviousData(hiddenForm.querySelectorAll('input'));

    activeForm.querySelectorAll('input').forEach(input => {
      handleMeasurementsData(input, measurements);
    });
  } else {
    form.querySelectorAll('input[type="checkbox"]').forEach(input => setInputAnswer(input));
    form.querySelectorAll('input[type="radio"]').forEach(e => {
      let value = document.querySelector('input[name=' + e.name + ']:checked').getAttribute('data-value');

      window.setAnswer(e.getAttribute('data-key'), value ? Number(value) : 0);
    });
    if (document.getElementById('noMeat')) {
      answerStore.setNoMeatChecked(0, document.getElementById('noMeat').checked);
    }
  }
};

/**
 * Submitting the user inputs and allows the user to move forward to the final page
 * @param {HTMLElement} form - Collection of the user inputs
 */
export const moveForward = form => {
  saveFormAnswers(form);
  let formAttributeHref = form.getAttribute('data-href');

  window.location.href = window.getHost() + (formAttributeHref ? formAttributeHref : form.getAttribute('action'));
};

/**
 * Checks if the current page is measurements page and allows the user to continue forward
 * @param {HTMLElement} button - The current target
 */
export const dietMove = button => {
  let form = button.closest('.dietMove');

  if (form.classList.contains('measurements')) {
    let event = document.createEvent('Event');
    event.initEvent('submit', true, true);
    document.getElementById('metric-imperial-form').dispatchEvent(event);
  } else {
    handleQuizProcess(getMultiSelectedAnswer(form), form, moveForward);
  }
};

/**
 * Checks if the user has checked any of the options and if not, displays a popup modal with options
 * @param {HTMLElement} button - The current target
 */
export const dietMoveWithWarningModal = button => {
  if (
    !document.querySelector('.number-of-checked:checked') &&
    document.querySelectorAll('.js-on-products-number').length &&
    !document.querySelector('#noMeat:checked')
  ) {
    let modal = document.querySelector('.products-modal');
    let progressBar = document.querySelector('.m-progress-bar__overlay');

    modal && (modal.style.display = 'block');
    progressBar && (progressBar.style.opacity = '1');
    progressBar && (progressBar.style.visibility = 'visible');
    progressBar && (progressBar.style.zIndex = '103');
  } else {
    dietMove(button);
  }
};

export const events = {
  inputAttribute: function () {
    document.querySelectorAll('input').forEach(input => {
      let answer = store.getAnswers();
      let inputDataAttributeKey = input.getAttribute('data-key');

      if (typeof answer[inputDataAttributeKey] === 'undefined') {
        return;
      }

      switch (input.getAttribute('type')) {
        case 'radio':
        case 'checkbox':
          let checked = Number(input.getAttribute('data-value')) === Number(answer[inputDataAttributeKey]);
          if (checked) {
            input.setAttribute('checked', checked);
          }
          break;
        case 'number':
          input.value = Number(answer[inputDataAttributeKey]);
          input.focus();
          input.blur();
          input.dispatchEvent(new Event('change'));
          break;
      }
    });
  },
  clickQuizButtons: function (quizButton) {
    quizButton.addEventListener('click', e => {
      dietAnswer(e.currentTarget);

      if (quizButton.dataset.coefficient) {
        store.set('age', quizButton.dataset.coefficient);
        store.set('age-range', quizButton.dataset.range);
      }
    });
  },
  clickContinueButton: function (continueButton) {
    continueButton.addEventListener('click', event => {
      dietMove(event.currentTarget);
    });
  },
  clickSelectMoreButton: function (selectMoreButton) {
    selectMoreButton.addEventListener('click', event => {
      event.preventDefault();
      let progressBar = document.querySelector('.m-progress-bar__overlay');

      let modal = '';

      if (document.querySelector('.products-modal') !== null) {
        modal = document.querySelector('.products-modal');
        modal.style.display = 'none';
      }

      progressBar && (progressBar.style.opacity = '0');
      progressBar && (progressBar.style.visibility = 'hidden');
      progressBar && (progressBar.style.zIndex = '101');
    });
  },
  clickDietMoveButton: function (dietMoveButton) {
    dietMoveButton.addEventListener('click', event => {
      event.preventDefault();
      let warningProductModal = parseInt(document.getElementById('warningModalIsEnabled')?.textContent);

      if (warningProductModal) {
        dietMoveWithWarningModal(event.currentTarget);
      } else {
        dietMove(event.currentTarget);
      }
    });
  },
  clickSubmitButton: function (dietMeasurementsButton) {
    dietMeasurementsButton.addEventListener('submit', ev => {
      ev.preventDefault();
      let inputArray = Array.from(document.getElementsByClassName('js-input'));

      let form = ev.currentTarget;
      const inputFields = [...inputArray].filter(f => f.offsetParent !== null);

      const changeEvent = new Event('change');
      inputFields.filter(e => e.required).forEach(input => input.dispatchEvent(changeEvent));

      const isInvalid = [...inputArray].filter(f => f.offsetParent !== null).some(e => e.dataset.valid === 'false');

      if (isInvalid) {
        return;
      }

      handleQuizProcess(getMeasurementsAnswer(inputFields), form, moveForward);
    });
  },
  clickClearAll: function () {
    let clearAll = document.querySelector('.clearAll input');

    document.querySelectorAll('input[type="checkbox"]').forEach(input => {
      if (input.checked) {
        if (input === clearAll) {
          clearAll.checked = true;
        } else {
          clearAll.checked = false;
        }
      }
    });

    clearAll.addEventListener('click', event => {
      let inputChecked = event.currentTarget.checked;

      document
        .querySelectorAll('input[type="checkbox"]:not(#' + event.currentTarget.getAttribute('id') + ')')
        .forEach(input => (input.checked = !inputChecked));

      handleSubmitBtnWhenOptionChecked();
    });
  },
  clickCheckbox: function (checkboxCollection) {
    checkboxCollection.forEach(checkbox => {
      checkbox.addEventListener('click', e => {
        if (!Array.from(document.getElementsByClassName('clearAll')).length || e.currentTarget.closest('.clearAll')) {
          // Needed for old designs
          handleSubmitBtnWhenOptionChecked();
          return;
        }

        let input = document.querySelector('.clearAll input');
        let hasChecked =
          document.querySelectorAll('input[type="checkbox"]:not(#' + input.getAttribute('id') + '):checked').length > 0;
        input.checked = !hasChecked;
        handleSubmitBtnWhenOptionChecked();
      });
    });
  },
  clickNoMeatButton: function (noMeat) {
    noMeat.addEventListener('click', e => {
      let checkboxes = Array.from(document.getElementsByClassName('a-checkbox'));
      let noMeatDisabled = Array.from(document.getElementsByClassName('no-meat-disabled'));
      let allChecked = Array.from(document.getElementsByClassName('number-of-checked'));

      if (e.currentTarget.checked) {
        answerStore.removeNoMeatProducts();

        let i = 0;
        allChecked.forEach(checkbox => {
          if (checkbox.checked) {
            answerStore.setNoMeatProducts(i++, checkbox);
            checkbox.checked = false;

            if (document.querySelector('.a-bradio')) {
              checkbox.closest('.a-bradio').classList.add('a-bradio--false');
            }
          }
          if (checkboxes) {
            checkboxes.forEach(el => {
              el.closest('.a-bradio').classList.remove('a-checkbox--false');
            });
          }
        });
        if (noMeatDisabled) {
          noMeatDisabled.forEach(el => (el.checked = true));
        }
      } else {
        if (answerStore.getProducts()[0]) {
          if (checkboxes) {
            checkboxes.forEach(el => el.closest('.a-bradio').classList.add('a-checkbox--false'));
          }

          for (const [key, product] of Object.entries(answerStore.getProducts())) {
            document.querySelector('#' + product).checked = true;
            document
              .querySelector('#' + product)
              .closest('.a-bradio')
              ?.classList.remove('a-bradio--false');
          }

          answerStore.removeNoMeatProducts();
        } else {
          allChecked.forEach(el => (el.checked = true));
        }
      }

      handleSubmitBtnWhenOptionChecked();
    });
  },
  selectMeatProducts: function (checkedWithMeat, noMeat) {
    noMeat = document.getElementById('noMeat');

    checkedWithMeat.forEach(el => {
      el.addEventListener('click', () => {
        if (noMeat && noMeat.checked) {
          answerStore.removeNoMeatProducts();
          noMeat.checked = false;
          if (document.querySelector('.a-bradio')) {
            noMeat.closest('.a-bradio').classList.add('a-checkbox--false');
          }
          answerStore.setNoMeatChecked(0, noMeat.checked);
        }

        if (document.querySelectorAll('.number-of-checked:checked').length === 0) {
          noMeat && (noMeat.checked = true);
          if (document.querySelector('.a-bradio')) {
            noMeat?.closest('.a-bradio').classList.remove('a-checkbox--false');
          }
        }

        handleSubmitBtnWhenOptionChecked();
      });
    });
  },
  back: function (backButtons) {
    for (const backButton of backButtons) {
      backButton.addEventListener('click', e => {
        history.back();
      });
    }
  },
};

export const setActiveStateToManyOfManySmall = () => {
  initializeAddClassMethod();
  const button = document.querySelectorAll('.js-active-control');

  function removeAllActive() {
    [...button].forEach(element => {
      const toRemoveActive = element.querySelectorAll('.js-active');
      [...toRemoveActive].forEach(e => {
        e.addClass('opacity-0');
      });
    });
  }

  [...button].forEach(element => {
    element.addEventListener('click', e => {
      removeAllActive();
      const toAddActive = e.currentTarget.querySelectorAll('.js-active');
      [...toAddActive].forEach(e => {
        e.classList.remove('opacity-0');
      });
    });
  });
};

export const redirectToUnfilledPage = () => {
  let localStoragePageIds = [];

  Object.keys(store.getAnswers()).forEach(answerKey => localStoragePageIds.push(answerKey.split('.')[0]));

  for (const [index, intoAttentionPageIdElement] of document.querySelectorAll('.page .page-id').entries()) {
    if (!localStoragePageIds.includes(intoAttentionPageIdElement.textContent)) {
      let intoAttentionPageSlug = document.querySelectorAll('.page .page-slug')[index].textContent;
      window.location.href = window.getHost() + '/' + intoAttentionPageSlug;
      break;
    }
  }

  isPagesFilled = true;
};

export const handleAgeFieldVisibility = () => {
  if (store.get('age')) {
    const ageFields = document.querySelectorAll('[data-type="age"]');
    ageFields.forEach(field => {
      field.value = store.get('age');
      field.parentElement.classList.add('hidden');
      document.querySelector('.js-unit').classList.remove('mb-10');
    });
  }
};

export function handleSubmitBtnWhenOptionChecked() {
  const dietMoveButton = document.querySelector('.dietMove #button-submit');
  const dietMoveButtonWrapper = document.querySelector('.dietMove #button-submit-wrapper');

  // querySelector('.a-bradio') Needed for old designs
  if (document.querySelector('.a-bradio') || dietMoveButton == null) {
    return;
  }

  if (document.querySelectorAll('input[type="checkbox"]:checked').length > 0) {
    dietMoveButton.removeAttribute('disabled');
    dietMoveButtonWrapper?.classList.remove('a-button--disabled');
  } else {
    dietMoveButton.setAttribute('disabled', true);
    dietMoveButtonWrapper?.classList.add('a-button--disabled');
  }
}

export const pages = () => {
  const startOverButton = document.querySelector('#start-over-button');
  startOverButton &&
    startOverButton.addEventListener('click', function () {
      window.location = '/';
    });

  if (document.querySelector('body').classList.contains('pb')) {
    events.inputAttribute();
  }

  document.querySelectorAll('.dietAnswer').forEach(quizButton => {
    events.clickQuizButtons(quizButton);
  });

  setActiveStateToManyOfManySmall();

  handleAgeFieldVisibility();

  const continueButton = document.querySelector('.dietMove #continue');

  if (continueButton !== null) {
    events.clickContinueButton(continueButton);
  }

  const selectMoreButtons = document.querySelectorAll('.js-modal-close');

  selectMoreButtons.forEach(button => events.clickSelectMoreButton(button));

  const selectMoreButton = document.getElementById('select-more');

  if (selectMoreButton) {
    events.clickSelectMoreButton(selectMoreButton);
  }

  const dietMoveButton = document.querySelector('.dietMove #button-submit');

  if (dietMoveButton) {
    events.clickDietMoveButton(dietMoveButton);
  }

  let dietMeasurementsButton = document.querySelector('.dietMove.measurements');

  if (dietMeasurementsButton) {
    events.clickSubmitButton(dietMeasurementsButton);
  }

  let clearAllButton = document.querySelector('.clearAll');

  if (clearAllButton) {
    events.clickClearAll();
  }

  let checkboxCollection = document.querySelectorAll('input[type="checkbox"]');

  if (checkboxCollection.length) {
    events.clickCheckbox(checkboxCollection);
    handleSubmitBtnWhenOptionChecked();
  }

  let noMeat = document.getElementById('noMeat');

  if (noMeat) {
    events.clickNoMeatButton(noMeat);
  }

  let backButton = document.getElementsByClassName('js-back-button');

  if (backButton) {
    events.back(backButton);
  }

  let checkedWithMeat = document.querySelectorAll('.number-of-checked, .no-meat-disabled');

  if (checkedWithMeat) {
    events.selectMeatProducts(checkedWithMeat, noMeat);
  }

  if (document.getElementById('check-answers').textContent === '1' || document.getElementById('generate-product')) {
    redirectToUnfilledPage();
  }

  if (document.getElementById('generate-product') && isPagesFilled) {
    const processingElement = document.getElementById('processing');
    window.setAnswer(processingElement.dataset.key, processingElement.dataset.value);
    let timeout = Math.floor(Math.random() * 500) + 500;

    setTimeout(function () {
      const screen = store.getMarketingInfo('screen');
      const ajaxUrl = backEndVars.systemType === 'diets' ? new Url().build('diets') : new Url().build('customers');
      const requestBody = {
        customerUuid: window.getCustomerUuid(),
        data: store.getAnswers(),
        marketing: {
          fingerprint: getFingerprint(),
          fbClientId: tracking.getFbClientId(),
          fbClickId: tracking.getFbClickId(),
          twClickId: tracking.getTwClickId(),
          gClickId: tracking.getGClickId(),
          refId: tracking.getRefId(),
          width: screen && screen.width,
          height: screen && screen.height,
          utmParams: store.getMarketingInfo('utmParams'),
          lastUtmParams: store.getMarketingInfo('lastUtmParams'),
        },
      };

      fetcher
        .post(ajaxUrl, requestBody, { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' })
        .then(data => {
          if (data.authRestrictionModal.isAuth) {
            const authModal = new GlobalModal();
            authModal.setConfig({
              buttons: [
                {
                  actionPostUrl: data.authRestrictionModal.data.firstButton.url,
                  text: data.authRestrictionModal.data.loginBtn,
                  isDeleteMethod: data.authRestrictionModal.data.firstButton.isDeleteMethod,
                  e2e: 'continue-new-mail',
                  id: data.authRestrictionModal.data.firstButton.id,
                },
                {
                  actionUrl: data.authRestrictionModal.data.secondButton.url,
                  text: data.authRestrictionModal.data.closeBtn,
                  e2e: 'continue-current-plan',
                  classList:
                    'text-link w-full mx-auto max-w-xs max-h-14 relative z-10 shadow-thetadrop bg-transparent overflow-visible ' +
                    'text-center text-base font-light rounded-12xl flex justify-center items-center ' +
                    'border border-theta focus:bg-iota text-tau ' +
                    'hover:bg-theta-gradient-2 hover:text-white a-button--big_border m-form-checkboxes__button',
                },
              ],
              content: {
                text: data.authRestrictionModal.data.text,
              },
              removeElements: ['closeBtn'],
            });
            authModal.init();

            stopLoader();

            document.getElementById('js-logout-and-create-customer').addEventListener('click', function () {
              store.remove('__cid');
              store.remove('__ph');
              store.remove('__eid');
              store.remove('isLoggedIn');
            });
            return;
          } else if (!data.customerInfo) {
            window.location.href = window.getHost() + '/404';
            return;
          }

          window.setCustomerUuid(data.customerInfo.customer_uuid);
          window.removeAnswersData();
          window.setAnswer('data', data.customerInfo);
          store.remove('paymentInit');
          store.remove('discountSeen');
          store.remove('nextUrl');
          store.remove('productsPaid');

          window.generateProductSuccess = true;
          if (data.redirectUrl) {
            processingElement.dataset.href = data.redirectUrl;
          }
        })
        .catch((error, textStatus, errorThrown) => {
          document.querySelector('.js-automatic-carousel')?.classList.add('hidden');
          stopLoader();
        });
    }, timeout);
  }

  function stopLoader() {
    document.getElementById('processing-text').style.display = 'none';
    document.getElementById('start-over-section').style.display = 'block';
    document.getElementById('error-text').style.display = 'block';

    if (window.onFail) {
      onFail();
    }

    const fbMessengerCheckbox = document.querySelector('.fb-messenger-checkbox');
    if (fbMessengerCheckbox) {
      fbMessengerCheckbox.style.display = 'none';
    }
  }
};

document.addEventListener('DOMContentLoaded', pages);
